import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import { TicketDetailPageContext, ticketDetailPageInitialState } from ".";

export const TicketDetailPageStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(ticketDetailPageInitialState);
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <TicketDetailPageContext.Provider value={context}>
      {children}
    </TicketDetailPageContext.Provider>
  );
};
